import React from 'react';
import {
  TableRow,
  TableCell,
  OverflowMenu,
  OverflowMenuItem
} from 'carbon-components-react';

const DisplayEmailRow: React.FC<any> = ({
  isRefferal,
  inboundEmailId,
  row,
  getRowProps,
  handleViewDetail,
  handleResend,
  handlePreviewEmail,
  handleDownload,
  handleSendToOther
}: any) => {
  return (
    <TableRow {...getRowProps({ row })}>
      <TableCell key={'sent'}>{row.cells[0]?.value}</TableCell>
      <TableCell key={'referral'}>{row.cells[1]?.value}</TableCell>
      {isRefferal ? (
        <TableCell key={'job'}>{row.cells[2]?.value}</TableCell>
      ) : (
        <TableCell key={'to'}>{row.cells[2]?.value}</TableCell>
      )}
      <TableCell key={'status'}>{row.cells[3]?.value}</TableCell>
      {
        <TableCell key="overflow" className="bx--table-column-menu">
          <OverflowMenu light flipped>
            <OverflowMenuItem
              itemText="Resend email"
              onClick={() => handleResend(row.id)}
              disabled={row.cells[4].value}
            />
            <OverflowMenuItem
              itemText="Send to other"
              onClick={() => handleSendToOther(row.id)}
              disabled={row.cells[4].value}
            />
            <OverflowMenuItem
              itemText="Preview email"
              onClick={() => handlePreviewEmail(row.id)}
            />
            {!isRefferal && inboundEmailId && (
              <OverflowMenuItem
                itemText="Download email"
                onClick={() => handleDownload(inboundEmailId)}
              ></OverflowMenuItem>
            )}
            <OverflowMenuItem
              itemText="View details"
              onClick={() => handleViewDetail(row.id, row.cells[4].value)}
            ></OverflowMenuItem>
          </OverflowMenu>
        </TableCell>
      }
    </TableRow>
  );
};
DisplayEmailRow.displayName = 'DisplayEmailRow';
export default DisplayEmailRow;
